
import { cn } from "@/lib/utils";

interface WordCardProps {
  word: string;
  onClick: () => void;
  selected?: boolean;
  disabled?: boolean;
  isLogicRule?: boolean;
}

export function WordCard({ word, onClick, selected, disabled, isLogicRule = false }: WordCardProps) {
  return (
    <div className="card-container">
      <button
        onClick={onClick}
        disabled={disabled}
        className={cn(
          "card-base",
          isLogicRule ? "logic-card" : "word-card",
          selected && "card-selected",
          disabled && "card-disabled"
        )}
      >
        <span className="card-text">
          {word.toLowerCase()}
        </span>
      </button>
    </div>
  );
}
